import { CSSProperties, ReactChild, RefObject } from "react";

import { IconTypes } from "./../../Icon";
import { AlignmentTypes } from "./../../../store/fields/boomtypes";

export enum TooltipBeginning {
    LEFT,
    CENTER,
    RIGHT,
}
export const beginningOfAlignment: { [key in AlignmentTypes]: TooltipBeginning } = {
    [AlignmentTypes.LEFT]: TooltipBeginning.LEFT,
    [AlignmentTypes.CENTER]: TooltipBeginning.CENTER,
    [AlignmentTypes.RIGHT]: TooltipBeginning.RIGHT,
};

export enum TooltipPosition {
    NONE = -2,
    CALCULATION,
    LEFT,
    TOP_LEFT,
    TOP_RIGHT,
    RIGHT,
    BOTTOM_RIGHT,
    BOTTOM_LEFT,
}

export interface IProps {
    content: ReactChild;
    children?: ReactChild;
    iconType?: IconTypes;
    iconSize?: number;
    initialPosition?: TooltipPosition;
    beginning?: TooltipBeginning;
    useClick?: boolean;
    usePortal?: boolean;
    activeButton?: boolean;
    className?: string;
    containerClassName?: string;
    getCloseAction?: (closeAction: () => void) => void;
    scrollElement?: HTMLElement | null;
    isValidationMode?: boolean;
    style?: CSSProperties;
}

export interface IContentProps {
    position: TooltipPosition;
    beginning: TooltipBeginning;
    tooltipDimensions: RefObject<ITooltipDimensions>;
    className?: string;
    content: ReactChild;
    isValidationMode?: boolean;
    changeTooltipRef: (e: HTMLDivElement) => void;
}

export interface ITooltipDimensions {
    height: number;
    width: number;
}

export interface ICashedListeners {
    onCheckClose(e: Event): void;
    onClose: () => void;
}

// Actions
interface IGetNewKeyForPositionUpdatingArgument {
    initialPosition: TooltipPosition;
    tooltipContainer: RefObject<HTMLElement>;
    tooltipDimensions: RefObject<ITooltipDimensions>;
}
export type IGetNewKeyForPositionUpdating = (argument: IGetNewKeyForPositionUpdatingArgument) => string;

interface IGetTooltipDimensionsArgument {
    tooltipDimensions: RefObject<ITooltipDimensions>;
    changeTooltipRef: (e: HTMLDivElement) => void;
}
export type IGetTooltipDimensions = (argument: IGetTooltipDimensionsArgument) => (e: HTMLDivElement) => void;
